module.exports = __webpack_public_path__ + "static/media/wcp_acc_pre.4a74c97d.png";